<div class="tw-flex tw-flex-col tw-text-white tw-items-center tw-justify-center glass-effect
tw-transition tw-duration-300 tw-ease-in-out tw-transform tw-p-2 md:tw-p-4">
    <!-- <icons-user></icons-user> -->
    <ng-content></ng-content>
    <span class="tw-text-xl md:tw-text-3xl pt-2 tw-font-bold tw-text-center">
        {{ count_text }}
    </span>
    <span class="tw-text-lg md:tw-text-xl tw-text-center tw-capitalize">{{ text }}</span>
</div>